import _ from 'lodash';
import * as pm from '../postMessage';

const extractSerializable = (obj) => _.omitBy(obj, (e) => _.isFunction(e));
const extractEvents = (obj) => _.pickBy(obj, (e) => _.isFunction(e));

function setComponentProps({controllerId, appDefinitionId, props}) {
    pm.sendMessageToHost(pm.Intent.WIX_CODE_SITE_API, {
        command: pm.MessageTypes.SET_TPA_NATIVE_COMPONENT_PROPS,
        appDefinitionId,
        data: {
            props,
            controllerId
        }
    });
}

function dataPartition(obj) {
    // first level
    const events = extractEvents(obj);
    const serialized = extractSerializable(obj);
    // second level
    _.forEach(serialized, (val, key) => {
        if (_.isObject(val) && !_.isArray(val)) {
            _.assign(events, _.mapKeys(extractEvents(val), (v, k) => `${key}.${k}`));
            _.assign(serialized, {[key]: extractSerializable(val)});
        } else {
            _.assign(serialized, {[key]: val});
        }
    });
    return {serializedData: serialized, events};
}

export function updateControllerData(contextId, currentRMI, controllerDataQuery, data) {
    const scopedRMI = currentRMI.getScopedRMI(controllerDataQuery);
    const controllerId = scopedRMI.getCompIdByDataQuery(controllerDataQuery);
    const {serializedData, events} = dataPartition(data);
    const eventsInfo = _.mapValues(events, (callback, eventName) => {
        const callbackId = scopedRMI.registerEventCallback({
            callback,
            overrideCallbackId: `${controllerId}-${eventName}`
        });
        return {callbackId, contextId};
    });
    setComponentProps({
        controllerId,
        appDefinitionId: scopedRMI.getAppDefinitionId(),
        props: {
            wixCodeProps: serializedData,
            events: eventsInfo
        }
    });
}


export function handleNativeEvent(RMI, {callbackId, eventArgs}) {
    const eventHandler = RMI.getCallbackById(callbackId);
    if (_.isFunction(eventHandler)) {
        eventHandler(...eventArgs);
    }
}
